import { ContainerStyled } from "./Container.styled";

export const Container = ({ children }) => {
  return <ContainerStyled className="container">{children}</ContainerStyled>;
};
